module.exports = __webpack_public_path__ + "7f6903ab483f87c9695c4eee52dff2aa.png";